import { CanActivateFn, Router } from '@angular/router'
import { inject } from '@angular/core'
import { PermissionService } from './permission.service'
import { Permission } from './permission.types'

export const permissionGuard =
  (...permissions: Permission[]): CanActivateFn =>
  () => {
    const permissionsSvc = inject(PermissionService)
    const router = inject(Router)

    if (permissionsSvc.canAny(...permissions)) {
      return true
    }

    return router.parseUrl('/sin-permisos')
  }

export const patientsImportGuard: CanActivateFn = () => {
  const permissionsSvc = inject(PermissionService)
  const router = inject(Router)

  if (permissionsSvc.canImportPatients()) {
    return true
  }

  return router.parseUrl('/pacientes')
}

/** Informe: elaborar (report) o ver en lectura (history + historia clínica). Operador raso excluido. */
export const informeConsultaGuard: CanActivateFn = () => {
  const permissionsSvc = inject(PermissionService)
  const router = inject(Router)

  if (permissionsSvc.canViewConsultationReport()) {
    return true
  }

  return router.parseUrl('/sin-permisos')
}
